import Lock from '@mui/icons-material/Lock'
import { useState } from 'react'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  ActivePlannedActivityBackdrop,
  LockedPlannedActivityOverlay,
  UAPActivityDetailsSubTitle,
  UAPActivityDetailsTitle,
  UAPDayItemEventDetailsContainer,
  UserActivityPlanPhaseDayItemContainer,
} from '../../MyPlanStyles'
import { APPhaseShowMoreText } from './styledComponent'

export function MobilePlanPhaseComponent({ phaseItem }) {
  const [isExpanded, setIsExpanded] = useState(false)

  function toggleExpand() {
    setIsExpanded((prev) => !prev)
  }

  return (
    <UserActivityPlanPhaseDayItemContainer
      active={true}
      noBorder
      // customBackground={phaseItem?.coverImage}
      customBackground={
        phaseItem?.coverIcon ? `url(${getImageLink(phaseItem?.coverIcon)})` : '#0000000f'
      }
      style={{
        overflow: 'hidden',
        borderRadius: '5px',
        boxShadow: 'rgb(0 0 0 / 22%) 0px 0px 8px 0px',
        zIndex: 4,
        margin: '10px 0px',
        // margin: '0px 0px 10px 0px'
      }}
    >
      <ActivePlannedActivityBackdrop />
      {!phaseItem?.started && (
        <LockedPlannedActivityOverlay style={{ zIndex: 2 }}></LockedPlannedActivityOverlay>
      )}
      <UAPDayItemEventDetailsContainer style={{ color: '#fff', zIndex: 3 }}>
        <div className="d-flex flex-column align-items-center gap-2 w-100">
          <UAPActivityDetailsSubTitle style={{ fontSize: '14px' }}>
            <span style={{ fontWeight: '600' }}>Day {phaseItem?.firstDay}</span> to{' '}
            <span style={{ fontWeight: '600' }}>Day {phaseItem?.lastDay}</span>
          </UAPActivityDetailsSubTitle>
          <UAPActivityDetailsTitle style={{ textAlign: 'center' }}>
            {phaseItem?.title}
          </UAPActivityDetailsTitle>
          {phaseItem?.started ? (
            <APPhaseShowMoreText
              lines={3}
              more="Show more"
              less="Show less"
              expanded={isExpanded}
              onClick={toggleExpand}
              truncatedEndingComponent={'... '}
            >
              {phaseItem?.description}
            </APPhaseShowMoreText>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Lock sx={{ fontSize: '35px' }} />
            </div>
          )}
        </div>
      </UAPDayItemEventDetailsContainer>
    </UserActivityPlanPhaseDayItemContainer>
  )
}
